import { useEffect, useState } from "react";

import type { DimensionIdGetResult } from "api/api.types";
import { useLazyGetDimensionQuery } from "api/dimensionApi.slice";
import { useSelector } from "common/utilities/react-redux";

export const useDimensions = (ids: string[]) => {
  const [fetchDimension] = useLazyGetDimensionQuery();
  const refetchHash = useSelector((state) => state.dimension.refetchHash);
  const [results, setResults] = useState<DimensionIdGetResult[]>([]);

  useEffect(() => {
    (() => refetchHash)();
    void Promise.all(
      ids.map((id) => fetchDimension({ id }, true).then((result) => (result.isSuccess ? result.data : undefined))),
    ).then((results) => setResults(results.filter((item) => item !== undefined)));
  }, [fetchDimension, ids, refetchHash]);

  return results;
};
